export const dashboardConstants = {
    DASHBOARD_UPDATE_DATE_RANGE: "DASHBOARD_UPDATE_DATE_RANGE"
};
